export enum Subject {
  ENGLISH = 1,
  MATH= 2
}